<template>
  <div class="modal" :class="isShow ? 'show' : ''" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header border-0 text-center text-white">
          <h3 class="modal-title w-100">Select {{ cardName }}</h3>
          <button
            type="button"
            class="close text-white"
            data-dismiss="modal"
            aria-label="Close"
            @click.prevent="hideModal()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="modal-scroll">
            <loading v-model:active="isLoading" />
            <p v-if="error">{{ error }}</p>
            <div class="row">
              <div class="col-3" v-for="(item, index) in info" :key="index">
                <a
                  href="#"
                  class="select_element selected-img"
                   @click.prevent="isSelected = !isSelected;addCard(item)"
                >
                  <img
                    class="img-fluid"
                    v-show="isImageLoaded"
                    :src="getImgUrl(item.data.img)"
                    :class="item.selected ? 'selected' : ''"
                    alt=""
                    @load="loaded"
                    @error="replaceByDefault(index)"
                  />
                  <img
                    v-if="imageFailed[index]"
                    class="img-fluid"
                    :class="item.selected ? 'selected' : ''"
                    :src="`http://ipfs.io/ipfs/${item.data.img}`"
                  />
                  <img
                    v-if="!isImageLoaded"
                    class="img-fluid"
                    :src="'/images/loader.gif'"
                  />
                </a>
              </div>
              <div class="col-12">
                <div class="attack_btn my-5 text-center">
                  <a href="#" @click.prevent="hideModal()">Select</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ApiService from "../services";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { mapGetters } from "vuex";
export default {
  name: "StakeModal",
  components: {
    Loading,
  },
  props: ["error", "showModel", "cardName", "schema", "isShow"],
  computed: {
    ...mapGetters(["selectedWeapon","selectedChars","myChars","myGuns"]),
  },
  showModal: true,
  data() {
    return {
      info: null,
      isLoading: false,
      isImageLoaded: false,
      apiRes: null,
      isSelected: false,
      imageFailed:[]
    };
  },
  mounted() {
    this.init(this.schema);
  },
  methods: {
    hideModal(e) {
      this.$emit("modal-hide", e);
    },
    loaded() {
      this.isImageLoaded = true;
    },

    getImgUrl(hash) {
      return ApiService.getImgUrl(hash);
    },
    replaceByDefault(i){
      this.imageFailed[i]=true;
    },
    addCard(item) {
      // var data = this.info;
      this.info = this.info.map((row, index) => {
        if (item.asset_id == row.asset_id) {
          this.info[index].selected = true;
          // delete data[index];
        } else {
          this.info[index].selected = false;
          // data.push(row);
        }
        return row;
      });

      this.$store.commit("addCard", item);
    },

    init(schema) {
      this.isLoading = true;
      if(schema=="guns" && this.myGuns){
        this.info = this.myGuns
      }else if(schema=="characters" && this.myChars){
        this.info = this.myChars
      }else{
        ApiService.callApi(
          `&collection_name=${process.env.VUE_APP_COLLECTION}&schema_name=${schema}`,
          (response) => {
            let res = response["data"];
            if (res["success"]) {
              this.apiRes = res["data"];
              this.info = this.apiRes
              if(schema=="characters"){
                if(this.selectedChars.length!=0){
                  var myids = this.selectedChars.map((item) => { return item.asset_id });
                  this.info = this.apiRes.filter(i=>myids.find(item=>item==i.asset_id)===undefined);
                }
              }
            } else {
              this.info = [];
            }
            this.isLoading = false;
          }
        );
      }
    },
  },
};
</script>
<style scoped>
.show {
  display: flex;
  align-items: center;
  background-color: rgb(0 0 0 / 65%); 
}

.show .modal-dialog {
  width: 100%;
}
.modal-overlay {
  content: "";
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 998;
  background: #2c3e50;
  opacity: 0.6;
  cursor: pointer;
}

.modal-content {
  border: 3px solid #eeac33;
  /*background-color: rgba(255, 255, 255, 0.6); 
  background-color: #000000;*/
  background-image: url(/images/map_bg.png);
  height: 100%;
  width: 100%;
  background-color: #875724;
}
.selected {
  border: 2px solid #eeac33;
  padding: 5px;
  transition: padding 0.4s;
}

.select_element {
  width: 85%;
  margin: 20px auto;
  display: block;
  transition: transform 0.4s;
  border:2px dotted #5c5959;
}
.modal-content .select_element:hover {
  transform: scale(1.05);
}

.dialog-enter-from,
.dialog-leave-to {
  opacity: 0;
  transform: scale(0.8);
}
.dialog-enter-active {
  transition: all 0.3s ease-out;
}
.dialog-leave-active {
  transition: all 0.3s ease-in;
}

.dialog-enter-to,
.dialog-leave-from {
  opacity: 1;
  transform: scale(1);
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s linear;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>